export default "__VITE_ASSET__22645b3f__"